module.exports = __webpack_public_path__ + "static/tasty-e9a52c8e1be6bcc9e62c92abe010a2e6.png";